export const SystemSettingsKeys = {
  Tax: 'vat_tax',
  SocialLinks: {
    Twitter: 'social_twitter',
    Facebook: 'social_facebook',
    Youtube: 'social_youtube',
    Linkedin: 'social_linkedin',
    TikTok: 'social_tiktok',
    Instagram: 'social_instagram',
  },
  WireTransferInfo: {
    accountNumber: 'wire_transfer_account_number',
    beneficiaryName: 'wire_transfer_beneficiary_name',
    swiftCode: 'wire_transfer_swift_code',
  },
  Discounts: {
    from1To4Videos: 'discount_1_4',
    from5To9Videos: 'discount_5_9',
    from10To14Videos: 'discount_10_14',
    from15AndAboveVideos: 'discount_15',
  },
};
